<script setup lang="ts">
const { size = 24, color = '#44445F' } = defineProps<{
  size?: number | string;
  color?: string;
}>();
</script>

<template>
  <svg :width="size" :height="size" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 5L16 12L10 19" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
